import { ExternalLink, Image, Text } from "@clipboard-health/ui-react";
import { IonPage } from "@ionic/react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, IconButton, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import cbhLogoHorizontalImage from "@src/appV2/lib/assets/images/cbhLogoHorizontal.png";
import { SupportArticleLinks, SupportArticles, SupportContext } from "@src/appV2/support/constants";

import { RootPaths } from "../App/paths";
import { AppBarHeader, PageWithHeader } from "../lib";

export function ErrorFallback() {
  return (
    <IonPage>
      <PageWithHeader
        containerMaxWidth="md"
        appBarHeader={
          <AppBarHeader
            title="Something went wrong"
            leftCta={
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="Go Back"
                title="Go Back"
                onClick={() => {
                  window.location.replace(RootPaths.HOME);
                }}
              >
                <ChevronLeftIcon fontSize="large" />
              </IconButton>
            }
          />
        }
      >
        <Stack
          alignItems="center"
          direction="column"
          justifyContent="center"
          textAlign="center"
          height="80vh"
        >
          <Box>
            <Text bold>Oops! Something went wrong.</Text>
            <br />
            <Text>Please go back or restart the app.</Text>
            <Text>If you keep having trouble, please reach out to our Support team.</Text>
            <br />
            <ExternalLink
              to={SupportArticleLinks.HOW_TO_CONTACT_SUPPORT}
              onClick={() => {
                logEvent(APP_V2_USER_EVENTS.OPENED_SUPPORT_ARTICLE, {
                  articleLink: SupportArticleLinks.HOW_TO_CONTACT_SUPPORT,
                  articleName: SupportArticles.HOW_TO_CONTACT_SUPPORT,
                  supportContext: SupportContext.ERROR_FALLBACK_SCREEN,
                });
              }}
            >
              Contact Our 24/7 Support Team
            </ExternalLink>
            <Box>
              <Image height={120} src={cbhLogoHorizontalImage} alt="Clipboard Health Logo" />
            </Box>
          </Box>
        </Stack>
      </PageWithHeader>
    </IonPage>
  );
}
